// src/hooks.client.ts

import { dev } from '$app/environment';

const RELOAD_KEY = '__reload_once__';

function reloadOnce() {
	if (sessionStorage.getItem(RELOAD_KEY)) return;

	sessionStorage.setItem(RELOAD_KEY, '1');

	// bypass SPA state completely
	location.reload();
}

if (!dev) {
	window.addEventListener('vite:preloadError', (event) => {
		console.error('Chunk load failed', event);
		reloadOnce();
	});

	window.addEventListener('unhandledrejection', (event) => {
		const msg = String(event.reason ?? '');

		if (
			msg.includes('Failed to fetch dynamically imported module') ||
			msg.includes('Importing a module script failed')
		) {
			reloadOnce();
		}
	});
}